@switch (displayType) {
    @case (displayTypeEnum.Link) {
        <div dsTouchClick (click)="tileClick()">
            <ng-container *ngTemplateOutlet="marqueeImageCardTemplate"></ng-container>
        </div>
    }
    @case (displayTypeEnum.Popup) {
        <div dsTouchClick (click)="openPopup()">
            <ng-container *ngTemplateOutlet="marqueeImageCardTemplate"></ng-container>
        </div>
    }
    @case (displayTypeEnum.View) {
        <ng-container *ngTemplateOutlet="marqueeImageCardTemplate"></ng-container>
    }
}

<ng-template #marqueeImageCardTemplate>
    @if (tile.imageUrl) {
        <img class="marquee-background-image" width="280" height="140" [priority]="trackingPosition === 0" [ngSrc]="tile.imageUrl" />
        <div
            [ngClass]="{
                'card-special-image__openOverlay': tile.ogpOverlay,
                'card-special-image': !tile.source?.isAutomatedMarquee,
                'card-special-image-automated': tile.source?.isAutomatedMarquee,
            }">
            @if (!tile.ogpOverlay) {
                <div>
                    <ng-container *ngTemplateOutlet="marqueeCardTemplate"></ng-container>
                </div>
            }
        </div>
    } @else {
        <ng-container *ngTemplateOutlet="marqueeCardTemplate"></ng-container>
    }
</ng-template>

<ng-template #marqueeCardTemplate>
    <div class="marquee-card-header" [class.card-promotional]="previousOdds">
        <ms-special-marquee-badge [tile]="tile"></ms-special-marquee-badge>
        @if (tile.event && !previousOdds) {
            <ms-scoreboard-time class="card-date" [event]="tile.event" [style.color]="tile?.source?.textColor"></ms-scoreboard-time>
        }
    </div>
    <div class="card-special">
        @if (isEpcotEnabled && optionGroupNames.length > 1) {
            @for (optionGroupName of optionGroupNames; track optionGroupName) {
                <span class="card-market-bullet">
                    <vn-icon class="marquee-bullet" size="12" [name]="'theme-open-bullet'"></vn-icon>
                    <span class="card-market" [style.color]="tile.source?.textColor">{{ optionGroupName }}</span>
                </span>
            }
        } @else {
            <div class="card-market" [style.color]="tile.source?.textColor">{{ optionGroupNames }}</div>
            <div class="card-event" [style.color]="tile.source?.textColor">{{ eventName }}</div>
        }
    </div>
    @if (tile.event && optionGroup?.options.length) {
        <div class="card-special-price card-special-price-right">
            @if (isEpcotEnabled && optionGroupNames.length > 1) {
                <div class="event-name" [style.color]="tile.source?.textColor">{{ eventName }}</div>
            }
            @if (previousOdds) {
                <div [ngClass]="{ 'card-special-prev-odds': isEpcotEnabled, 'card-special-price-prev': !isEpcotEnabled }">
                    <span class="cs-text" [style.color]="tile?.source?.textColor">{{ sitecore.marquee.Was }}</span>
                    <span class="cs-price" [style.color]="tile?.source?.textColor">{{ previousOdds }}</span>
                </div>
            }

            <div class="card-special-odds-prev">
                <ms-option-group
                    [optionGroup]="optionGroup"
                    [event]="tile.event"
                    [isOneWaySpecial]="true"
                    [isFromPortal]="tile?.isFromPortal"
                    [isPriceBoosted]="tile.isPriceBoosted"
                    [tracking]="{
                        source: trackingSource,
                        position: trackingPosition,
                        marqueeName: tile.trackingDetail?.marqueeName,
                        sitecoreTemplateId: tile.trackingDetail?.sitecoreTemplateId,
                        marqueeType: tile.source?.marqueeType,
                        isAutomatedMarquee: !!tile.source?.isAutomatedMarquee,
                    }">
                </ms-option-group>
            </div>
        </div>
    } @else if (tile.fixtureId) {
        <div class="bet-now-bottom-alignment">
            <ms-bet-now-button [event]="tile.event"></ms-bet-now-button>
        </div>
    }
</ng-template>

<ng-template #ogpOverlayHeader>
    <ms-betbuilder-overlay-header
        [eventName]="tile.event?.name"
        [sportId]="tile.sportId"
        [leagueId]="tile.source?.competitionId"
        [eventId]="tile.fixtureId"
        [eventStartDate]="tile.event.startDate"
        [eventParticipants]="tile.event.participants"
        [eventViewType]="tile.event.viewType"></ms-betbuilder-overlay-header>
</ng-template>
